import React, { useState } from "react";
import PropTypes from "prop-types";

import HallBlock from "../HallBlock/HallBlock";
import TrainerBlock from "../TrainerBlock/TrainerBlock";

import { HocWithPreloader } from "../../../../../hocs/hocWithPreloader";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useQuery } from "@apollo/client";
import { GET_INSTRUCTORS } from "../../../../../graphql/queries/queriesInstuctor";
import { useAuth } from "../../../../../utils/auth";

const HallTrainerSection = ({ icon, halls }) => {
  const [t] = useTranslation();
  const router = useRouter();
  const {
    query: { refName, hallsetId },
  } = router;
  const { accessToken } = useAuth();

  const [activeHallId, setActiveHallId] = useState(+(hallsetId || halls[0].id));

  const { data: { instructors = [] } = {}, loading } = useQuery(
    GET_INSTRUCTORS,
    {
      fetchPolicy: "cache-and-network",
      variables: { hallId: activeHallId, accessToken },
    }
  );

  // const ref = useRef(null);
  // const navRefs = useMemo(() => ({ [HALL_REF]: ref }), []);
  // useSmoothScroll(navRefs, refName, { time: 1 });

  return (
    <section className="hall-trainer-section main-padding-block club-page--background">
      <div className="container">
        <h2 className="club-page-title hall-trainer-title">
          {t("locations_and_instructors")}
        </h2>

        {!!halls.length && (
          <HallBlock
            activeHallId={activeHallId}
            setActiveHallId={setActiveHallId}
            halls={halls}
            icon={icon}
          />
        )}
        <HocWithPreloader isLoading={loading} data={instructors}>
          <TrainerBlock allInstructors={instructors} hallsetId={activeHallId} />
        </HocWithPreloader>
      </div>

      <style jsx global>{`
        @import "./HallTrainerSection.scss?";
      `}</style>
    </section>
  );
};

HallTrainerSection.propTypes = {
  icon: PropTypes.string,
  halls: PropTypes.array,
};

HallTrainerSection.defaultProps = {
  icon: "",
  halls: [],
};

export default HallTrainerSection;
